// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3964) return "static/chunks/3964-8a9654154de44820.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "4968b38aa25ad212" + ".js";
};